import { NCmsComponentListing } from '../../../component/listing/cms-component-listing.interface';

export namespace NCmsBlogComponentListingV2 {
    export const ID = 'blog-listing-v2';

    export interface IData extends NCmsComponentListing.IData {
        hero_posts: boolean;
        heading?: string;
        text_style?: string;
        color?: string;
        cta_copy?: string;
    }
}
